import { Box, Typography, Grid } from "@mui/material";
import { useEffect, useState } from "react";

import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

// Icons
import GoogleIcon from "@mui/icons-material/Google";
import StarIcon from "@mui/icons-material/Star";
import { useSelector } from "react-redux";

const ReviewBar = () => {
  const theme = useTheme();
  const smUp = useMediaQuery(theme.breakpoints.up("sm"));

  // Store
  const { webSettings } = useSelector((state) => state.webSettings);
  const { managedContentSettings } = useSelector(
    (state) => state.managedContentSettings
  );
  const { activeLangFront } = useSelector((state) => state.miscFront);

  const [contentSettings, setContentSettings] = useState([]);
  const [langId, setLangId] = useState("");

  useEffect(() => {
    if (activeLangFront) setLangId(activeLangFront._id);
  }, [activeLangFront]);

  // Set Settings
  useEffect(() => {
    if (
      managedContentSettings &&
      managedContentSettings.length > 0 &&
      langId !== ""
    ) {
      const M = managedContentSettings.find((m) => m.langId === langId);
      if (M) {
        setContentSettings(M);
      }
    }
  }, [langId, managedContentSettings]);

  useEffect(() => {}, [webSettings]);
  return (
    <Box
      sx={{
        backgroundColor: "rgb(47, 51, 110)",
        py: 1,
        color: "white",
      }}
    >
      <Grid
        container
        spacing={0}
        alignItems={"center"}
        justifyContent={"space-evenly"}
      >
        {smUp && (
          <Grid item>
            <Typography
              variant="subtitle1"
              color="white"
              sx={{ fontWeight: "bold" }}
            >
              Call Our Support:{" "}
              {contentSettings.footerContactInfo &&
              contentSettings.footerContactInfo.contactNumber &&
              contentSettings.footerContactInfo.contactNumber.length > 0
                ? contentSettings.footerContactInfo.contactNumber.join(", ")
                : ""}
            </Typography>
          </Grid>
        )}

        <Grid item>
          <Box
            sx={{
              display: "flex",
              gap: 2,
              cursor:
                webSettings?.googleReviewUrlElife?.length > 2
                  ? "pointer"
                  : "auto",
            }}
            onClick={() =>
              webSettings?.googleReviewUrlElife?.length > 2
                ? window.open(webSettings.googleReviewUrlElife, "_blank")
                : null
            }
          >
            <GoogleIcon fontSize="large" sx={{ mt: 0.5 }} />
            <Box>
              <Typography
                variant="body2"
                color="white"
                sx={{ textDecoration: "underline" }}
              >
                Google Reviews
              </Typography>
              <Grid container spacing={0} alignItems={"center"}>
                <Typography
                  variant="body2"
                  color="white"
                  sx={{ mr: 0.5, fontWeight: "bold" }}
                >
                  {webSettings.googleReviewCountElife}
                </Typography>
                <StarIcon fontSize="8" color="warning" />
                <StarIcon fontSize="8" color="warning" />
                <StarIcon fontSize="8" color="warning" />
                <StarIcon fontSize="8" color="warning" />
                <StarIcon fontSize="8" color="warning" />
              </Grid>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ReviewBar;
